'use strict';

import 'document-register-element';
import light from './light';
import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';
import {isTouch} from '../utils';


export class MaskLight extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._previousMoveEvent = {x: 0, y: 0};

    if (isTouch()) return;

    this._isStopped = this.dataset.stopped === 'true';

    this._transform = +this.dataset.transform || 0;
    this._scrolled = 0;
    this._width = 0;
    this._height = 0;
    this._top = 0;
    this._left = 0;

    this._setted = false;

    this.onResize = (e) => this._onResize(e);
    this.onScroll = (e) => this._onScroll(e);
    this.onMove = (e) => this._onMove(e);
    this.subscribe = (e) => (e.type === 'page-size-change' || e.type === 'spoiler-change' || e.type === 'mutate') && this._onResize(resizeStore.getData());
  }
  connectedCallback() {
    if (isTouch()) return;

    this._onResize();
    resizeStore.eventEmitter.subscribe(this.onResize);
    dispatcher.subscribe(this.subscribe);
    window.addEventListener('scroll', this.onScroll);

    if (!this._isStopped) light.addListener(this.onMove);
  }
  disconnectedCallback() {
    if (isTouch()) return;

    resizeStore.eventEmitter.unsubscribe(this.onResize);
    dispatcher.unsubscribe(this.subscribe);
    window.removeEventListener('scroll', this.onScroll);
    light.removeListener(this.onMove);
  }

  _onResize(e) {
    this._scrolled = window.scrollY;

    const thisBounds = this.getBoundingClientRect();
    this._width = thisBounds.width;
    this._height = thisBounds.height;
    this._left = thisBounds.left;
    this._top = thisBounds.top + this._scrolled - thisBounds.height * this._transform;
    // this._width = this.offsetWidth;
    // this._height = this.offsetHeight;
    // this._left = this.offsetLeft;
    // this._top = this.offsetTop + this._scrolled;

    this._onScroll();
  }
  _onScroll() {
    this._scrolled = window.scrollY;

    this._onMove();
  }
  _onMove(e = this._previousMoveEvent) {
    const x = e.x - this._left;
    const y = e.y - this._top + this._scrolled;

    if (x > -100 && x < this._width + 100 &&
        y > -100 && y < this._height + 100) {
      this.style.setProperty('--x', `${x}px`);
      this.style.setProperty('--y', `${y}px`);

      this._setted = false;
    } else {
      if (!this._setted) {
        this.style.setProperty('--x', `-100px`);
        this.style.setProperty('--y', `-100px`);

        this._setted = true;
      }
    }

    this._previousMoveEvent = e;
  }
  on() {
    if (this._isStopped) {
      this._onMove({x: light.x, y: light.y});
      light.addListener(this.onMove);
      this._isStopped = false;
    }
  }
  off() {
    if (!this._isStopped) {
      light.removeListener(this.onMove);
      this._isStopped = true;
    }
  }
}


window.customElements.define('mask-light', MaskLight);